// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapComponent_mapContainer__NsMqU {
  position: relative;
  height: 100%;
  width: 100%;
}

.MapComponent_mapControls__rBJGv {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
}

.MapComponent_controlButton__sGKfz {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 8px;
  cursor: pointer;
  font-size: 1rem;
}

.MapComponent_controlButton__sGKfz:hover {
  background: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/components/MapComponent.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".mapContainer {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.mapControls {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  z-index: 1000;\r\n}\r\n\r\n.controlButton {\r\n  background: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  padding: 6px 8px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n}\r\n\r\n.controlButton:hover {\r\n  background: #f0f0f0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapContainer": `MapComponent_mapContainer__NsMqU`,
	"mapControls": `MapComponent_mapControls__rBJGv`,
	"controlButton": `MapComponent_controlButton__sGKfz`
};
export default ___CSS_LOADER_EXPORT___;
